import React from 'react';

// Content here copied from https://github.schibsted.io/finn/favicons/blob/master/lib/index.js
export default function FavIcons() {
    return (
        <>
            <link rel="icon" href="https://www.finn.no/favicon.ico" />
            <link rel="icon" href="https://www.finn.no/favicon-t-32x32.png" sizes="32x32" />
            <link rel="icon" href="https://www.finn.no/favicon-t-192x192.png" sizes="192x192" />
            <link rel="icon" href="https://www.finn.no/favicon-t-96x96.png" sizes="96x96" />
            <link rel="icon" href="https://www.finn.no/favicon-t-16x16.png" sizes="16x16" />
            <link rel="apple-touch-icon" href="https://www.finn.no/apple-touch-icon-180x180.png" />
            <meta name="msapplication-TileColor" content="#06befb" />
            <meta name="msapplication-TileImage" content="https://www.finn.no/mstile-144x144.png" />
            <meta name="theme-color" content="#fafafa" />
            <meta name="msapplication-config" content="https://www.finn.no/browserconfig.xml" />
            <link rel="manifest" href="https://www.finn.no/manifest.json" />
        </>
    );
}
